// components/LuggageModal.jsx
import React, { useMemo, useState } from 'react';

const eur = (n) =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n || 0);

export default function LuggageModal({
  open,
  onClose,
  travellers = [],        // [{id:'T1', type:'Adult', label:'Adulte 1'}, ...]
  options = [],           // [{code,label,ppa,ppc,quantities:{adult:{},child:{}}}, ...]
  defaultSelection = {},  // {T1: null|'code', ...}
  onConfirm,              // (selection, total) => void
}) {
  const [sel, setSel] = useState(defaultSelection);

  const optionPriceFor = (trav) => {
    const opt = options.find(o => o.code === sel[trav.id]);
    if (!opt) return 0;
    return trav.type === 'Child' ? (opt.ppc ?? opt.ppa ?? 0) : (opt.ppa ?? opt.ppc ?? 0);
  };

  const total = useMemo(
    () => travellers.reduce((sum, t) => sum + optionPriceFor(t), 0),
    [travellers, sel, options]
  );

  const allowed = (trav, opt) => {
    const q = opt.quantities || {};
    return trav.type === 'Child'
      ? (q.child?.max ?? 99) > 0
      : (q.adult?.max ?? 99) > 0;
  };

  if (!open) return null;

  return (
    <>
 {open && (
  <div
    className="modal fade show"
    style={{
      display: 'block',
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 1055,
    }}
    tabIndex="-1"
    onClick={onClose}
  >
    <div
      className="modal-dialog modal-dialog-centered modal-lg"
      onClick={(e) => e.stopPropagation()} // éviter la fermeture au clic intérieur
    >
      <div className="modal-content border-0 shadow">
        {/* --- HEADER --- */}
        <div className="modal-header border-0 pb-0">
          <h5 className="modal-title fw-semibold">Options bagages</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>

        {/* --- BODY --- */}
        <div className="modal-body pt-3">
          <div className="text-muted small mb-3">
            Une seule option peut être choisie par personne.
          </div>

          <div>
            {travellers.map((t) => (
              <div key={t.id} className="row g-2 align-items-center mb-2">
                <div className="col-4 fw-medium">{t.label}</div>
                <div className="col-8">
                  <select
                    className="form-control"
                    value={sel[t.id] ?? ''}
                    onChange={(e) =>
                      setSel((s) => ({
                        ...s,
                        [t.id]: e.target.value || null,
                      }))
                    }
                  >
                    <option value="">— Aucun supplément —</option>
                    {options.map((o) => (
                      <option
                        key={o.code}
                        value={o.code}
                        disabled={!allowed(t, o)}
                      >
                        {o.label} •{' '}
                        {eur(
                          t.type === 'Child'
                            ? o.ppc ?? o.ppa
                            : o.ppa ?? o.ppc
                        )}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* --- FOOTER --- */}
        <div className="modal-footer border-0 pt-0">
          <div className="me-auto fw-semibold">
            Total supplément : {eur(total)}
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              onConfirm(sel, total);
              onClose();
            }}
          >
            Valider
          </button>
        </div>
      </div>
    </div>
  </div>
)}
</>
  );
}
